import ModalMenu from "./ModalMenu";

export default ModalMenu;
